<template>
  <div class="choose-plan">
    <div v-if="false" class="plan-filters">
      <el-select placeholder="Choose datacenter">
        <el-option>All cities</el-option>
      </el-select>
    </div>

    <el-tabs v-model="cpu">
      <el-tab-pane v-if="shared.length > 0" label="Shared CPU" name="shared">
        <div class="cpu-information">Basic Cloud Server for small projects and dev/test environments.</div>

        <el-tabs v-model="provider" tab-position="left">
          <el-tab-pane
            v-for="provider in getProviders(shared)"
            :key="provider"
            :label="provider"
            :name="provider"
          >
            <el-row :gutter="10">
              <el-col
                v-for="plan in shared.filter((p) => p.provider.name === provider)"
                :key="plan.id"
                :span="8"
              >
                <Plan :plan="plan" shadow="hover" @select="$emit('update:planId', $event)"  />
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>

      <el-tab-pane label="Dedicated CPU" name="dedicated">
        <div class="cpu-information">High performance Cloud Servers for a wide range of production workloads.</div>

        <el-tabs v-model="provider" tab-position="left">
          <el-tab-pane
            v-for="provider in getProviders(dedicated)"
            :key="provider"
            :label="provider"
            :name="provider"
          >
            <el-row :gutter="10">
              <el-col
                v-for="plan in dedicated.filter((p) => p.provider.name === provider)"
                :key="plan.id"
                :span="8"
              >
                <Plan :plan="plan" shadow="hover" @select="$emit('update:planId', $event)" />
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Plan from './Plan'

export default {
  props: {
    planId: String,
    country: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Plan
  },
  data () {
    return {
      cpu: 'shared',
      provider: null,
      datacenter: null
    }
  },
  mounted () {
    this.setup()
  },
  computed: {
    countryPlans () {
      const all = this.country ? this.country.plans || [] : []
      const plans = {}
      all.forEach((plan) => {
        const key = `${plan.provider.name}-${plan.name}-${plan.memory}-${plan.vcpus}-${plan.storage}`
        plans[key] = plans[key] || plan
        plans[key].datacenters = plans[key].datacenters || {}
        plans[key].datacenters[plan.region.name] = plans[key].datacenters[plan.region.name] || {}
        plans[key].datacenters[plan.region.name][plan.provider.datacenter] = plan.id
      })
      return Object.values(plans)
    },
    shared () {
      return this.countryPlans.filter((p) => p.cpu === 'Shared')
    },
    dedicated () {
      return this.countryPlans.filter((p) => p.cpu === 'Dedicated')
    }
  },
  methods: {
    getProviders (plans) {
      const providers = {}
      plans.forEach((plan) => {
        providers[plan.provider.name] = true
      })
      return Object.keys(providers).sort((a, b) => a.localeCompare(b))
    },
    setup () {
      this.cpu = this.shared.length > 0 ? 'shared' : 'dedicated'
      this.provider = this.getProviders(this[this.cpu])[0]
    }
  },
  watch: {
    shared () {
      this.$nextTick(this.setup)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .choose-plan {
    margin-left: -20px;
    margin-right: -20px;
  }
  .plan-filters {
    padding: 20px;
  }
  .choose-plan {
    .el-col {
      margin-bottom: 10px;
    }
  }
  .cpu-information {
    background-color: $--background-color-base;
    margin-left: -20px;
    padding: 20px;
  }
</style>

<style lang="scss">
  @import "../../theme";

  .choose-plan > .el-tabs {
    > .el-tabs__header .el-tabs__nav-wrap, > .el-tabs__content {
      padding-left: 20px;
    }

    > .el-tabs__header.is-top {
      margin-bottom: 0;
    }

    #pane-shared, #pane-dedicated {
      .el-tabs {
        margin-top: 10px;
        margin-right: 10px;
      }
      .el-tabs__header {
        margin-right: 0;
      }
      .el-tabs__item {
        padding-left: 0;
      }
      .el-tab-pane {
        padding-left: 10px;
        padding-bottom: 20px;
      }
      .el-card__header {
        text-align: center;
        padding: 0 !important;

        h4 {
          margin: 0;
          padding: 10px;

          &.sandbox {
            background-color: $--background-color-base;
            color: $--color-text-gray;
          }
          &.basic, &.premium-intel,  &.general-purpose {
            background-color: $--background-color-base;
            color: $--color-text-primary;
          }
          &.cpu-optimized, &.memory-optimized {
            background-color: $--background-color-base;
            color: $--color-danger;
          }
        }
      }
      .el-card__header, .el-card__body {
        padding: 10px;
      }
    }
  }
</style>
